<div class="take-survey-wrapper w-full md:m-[0] sm:mt-[2rem]">
  <div class="title-wrapper w-[95%]">
    <div class="title-section">
      <div class="title-content">
        {{title}}
      </div>
      <div class="description-content">
        {{description}}
      </div>
    </div>
  </div>
  <div class="form-wrapper w-[95%] flex justify-center">
    <hr class="w-[95%] separator">
  </div>

  <div class="survey-form-wrapper w-[95%] flex justify-center">
    <div *ngIf="surveyJson.elements.length>0"
         class="w-[95%]">
      <survey [model]="surveyModel"></survey>
    </div>
  </div>
</div>
